import ConfirmationDialog from "@Components/app/common/confirmation-dialog";
import { faScrewdriverWrench } from "@fortawesome/pro-solid-svg-icons";
import { useState } from "react";

const ServiceOutageBlocker = ({
  open, 
  onExit = ()=> {}, 
  isUnityEmbedded = false,
  isSuperAdmin = false
} : { 
  open: boolean, 
  onExit?: () => void, 
  isUnityEmbedded?: boolean,
  isSuperAdmin?: boolean 
}) => {

  const [isOpen, setIsOpen] = useState<boolean>(open);

  return (
    <ConfirmationDialog
      open={isOpen}
      disableCancel={isSuperAdmin ? false : true}
      onCancel={()=> {setIsOpen(false)}}
      dialogProps={{
        open,
        disableEscapeKeyDown: true
      }}
      iconProps={{
        icon: faScrewdriverWrench,
        size: '6x',
        sx: {
          padding: theme => theme.spacing(3),
          color: theme => theme.palette.dsNeutral.v300
        }
      }}
      disableConfirm={isUnityEmbedded === false}
      title="We're experiencing some issues"
      message="Apologies, there is a temporary network outage affecting our service. The service will be back online as soon as possible."
      confirmLabel='button.exit.app'
      onConfirm={onExit}
    />
  );
};

export default ServiceOutageBlocker;